import React from 'react';
import { Tag } from '../Tag/Tag.jsx';

const h = React.createElement;

/**
 * Tilted mono stamp for ephemeral states only (DELIVERED, SAVED, NEW). Pops on arrival. Gold
 * unless a tone is given.
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {'neutral'|'green'|'amber'|'red'|'blue'|'purple'|'lime'|'gold'|'coral'|'paper'} [p.tone]
 * @param {React.CSSProperties} [p.style]
 * @param {React.MouseEventHandler} [p.onClick]
 * @param {string} [p.title]
 */
export const Stamp = (p) => h(Tag, { ...p, stamp: true });
